import React from "react";
import { motion } from "framer-motion";
import clsx from "clsx";

interface TechCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  delay?: number;
  className?: string;
}

export function TechCard({ title, description, icon, delay = 0, className }: TechCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.5, delay }}
      className={clsx(
        "group relative p-6 glass-panel overflow-hidden transition-colors hover:border-neon-cyan/50",
        className
      )}
    >
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-neon-cyan to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
      
      <div className="mb-6 inline-flex p-3 rounded-lg bg-white/5 text-neon-cyan group-hover:scale-110 group-hover:text-neon-magenta transition-all duration-300">
        {icon}
      </div>
      
      <h3 className="text-xl font-bold text-white mb-3 tracking-wide">{title}</h3>
      <p className="text-gray-400 text-sm leading-relaxed">{description}</p>
      
      {/* Decorative corner accents */}
      <div className="absolute top-0 left-0 w-2 h-2 border-t border-l border-white/20 group-hover:border-neon-cyan transition-colors m-2"></div>
      <div className="absolute bottom-0 right-0 w-2 h-2 border-b border-r border-white/20 group-hover:border-neon-cyan transition-colors m-2"></div>
    </motion.div>
  );
}
